export default __webpack_public_path__ + "static/media/playson.71071d31.png";